const MIN_GPAX = 0;
const MAX_GPAX = 4;

const isValidGpax = (gpax) => {
  if (typeof gpax !== 'number' && typeof gpax !== 'string') return false;
  if (!/^\d+(\.\d+)?$/.test(String(gpax).trim())) return false;
  const gpaxNumber = Number(gpax);
  return Number.isFinite(gpaxNumber) && gpaxNumber >= MIN_GPAX && gpaxNumber <= MAX_GPAX;
};
const GPAX_FIELDS = ['gpax4_score', 'gpax5_score', 'gpax6_score'];
const hasGpax = (value) => value != null && value !== '';
const invalidGpaxFields = (data = {}) => GPAX_FIELDS.filter((key) => hasGpax(data[key]) && !isValidGpax(data[key]));
// Missing values are allowed in a profile; a formula may only use validated values.
const canCalculateGpax = (student, project) => {
  if (invalidGpaxFields(student).length) return false;
  const scores = project.scores || {};
  const calculatedSubjects = scores.cal_type ? String(scores.cal_subject_name || '').split(/[\s|]+/) : [];
  return ['gpax', ...GPAX_FIELDS].every((key) =>
    !(Number(scores[key]) || calculatedSubjects.includes(key)) || isValidGpax(student[key === 'gpax' ? 'gpax6_score' : key]));
};

export { isValidGpax, GPAX_FIELDS, invalidGpaxFields, canCalculateGpax };
